@use '../../../styles/variables' as *;
@use '../../../styles/mixins' as *;

.hud {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  color: $color-text-white;
  font-size: $font-md;
  pointer-events: none;
}

.group {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 0, 0, 0.55);
  padding: 5px 10px;
  border-radius: $radius-md;
  backdrop-filter: blur(4px);
  width: fit-content;

  &:first-child {
    justify-self: start;
  }

  &:last-child {
    justify-self: end;
  }
}

.groupTransparent {
  background: none;
  backdrop-filter: none;
  padding: 0;
}

.separator {
  opacity: 0.3;
  font-size: $font-sm;
}

.waveTimer {
  display: inline-block;
  min-width: 2ch;
  text-align: left;
}

.amount {
  display: inline-block;
  min-width: 4ch;
  text-align: left;
}

.hpHeart {
  font-size: $font-md;
  flex-shrink: 0;
}

.hpBar {
  width: 140px;
  height: 18px;
  background: $color-hp-bar-bg;
  border-radius: 9px;
  overflow: hidden;
  position: relative;
}

.hpFill {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, $color-hp-start, $color-hp-end);
  transition: width $transition-fast;
}

.hpText {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: $font-xs;
  font-weight: bold;
  text-shadow: 1px 1px 2px black;
}

.countdownWarning {
  color: $color-danger;
  animation: pulse-warning 0.5s ease-in-out infinite;
}

@keyframes pulse-warning {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
